import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import Fretboards from "./fretboard/Fretboards";
import SettingsBar from "./settings/SettingsBar";
import metaActions from "../state/meta/actions";
import store from "../store";

import "./App.scss";

function App() {
	const [displayType, setDisplayType] = useState("");
	const location = useLocation();

	useEffect(() => {
		if (/\/embed$/.test(location.pathname)) {
			document.documentElement.classList.add("embed");
			setDisplayType("embed");

			store.dispatch(metaActions.update({
				// Default values for embed
				fretboardConfig: 1,
				selectedKey: 64,
				highlight: null
			}));
		} else {
			document.documentElement.classList.remove("embed");
			setDisplayType("");
		}
	}, [location]);

	return (
		<div className="app-container">
			{!displayType ? <h1>Andy&#8217;s Fretboard</h1> : null}
			<SettingsBar displayType={displayType} />
			<Fretboards displayType={displayType} />
		</div>
	);
}

export default App;
